<template>
  <section >
    <!-- <a href="https://giphy.com/bublywater" target="_blank" class="bubble"><span>meet all 8 flavors</span></a> -->
    <p>no <span>calories</span></p>
    <p>no <span>sweeteners</span></p>
    <p>all <span>smiles<span class="super">&#8482;</span></span></p>
  </section>
</template>


<script>
  export default {
    name: 'allSmiles'
  };
</script>

<style lang='scss' scoped>
  @import './../variables';
  $bubble-radius: 120px;
  $bubble-radius-desktop: 174px;

  section {
    background-color: $bubly-blue;
    padding: 15px;
    position: relative;
    overflow: hidden;

    @include breakpoint('tablet') {
      padding: 0;
    }
  }

  p {
    font-size: 29px;
    // padding: 40px 15px;
    margin: 20px 0;
    // padding: 0;
    position: relative;
    // 
    // width: 100%;
    // max-width: 540px;
    font-weight: bold;
    span {
    color: $bubly-turquoise;
    }
    .super {
    font-size: 14px;
    position: absolute;
    top: 0;
    }
    @include breakpoint('tablet') {
    font-size: 40px;
    display: inline-block;
    margin: 40px 15px;
    }
}

 
  
</style>



// WEBPACK FOOTER //
// src/components/AllSmiles.vue